export const ALL_OPTION = 'all';
export const OTHER_GROUP = 'other';
